import { memo } from 'react';
import md5 from 'md5';
const memoHoc = (component, compareAttributes) => {
  const areEqual = (prevProps, nextProps) => {
    const equal = compareAttributes.reduce((equal, att) => {
      equal = equal && prevProps[att] && nextProps[att] && md5(JSON.stringify(prevProps[att])) === md5(JSON.stringify(nextProps[att]));
      return equal;
    }, true);
    return equal;
  };
  return /*#__PURE__*/memo(component, areEqual);
};
export { memoHoc };